import Modal from "../../../../parts/modal-new";

export const GymModalComponent = ({ locals }) => {
  const { activeGymLocation = {} } = locals;
  const { gymName = "", days = [] } = activeGymLocation;

  const formatHours = (hour) => {
    const hourBase = hour.substring(0, 2); //09
    const minutes = hour.substring(hour.length - 3); //:50
    let finalHour = "";
    if (hourBase === "12") {
      finalHour = `12${minutes} PM`;
    } else if (hourBase === "13") {
      finalHour = `01${minutes} PM`;
    } else if (hourBase === "14") {
      finalHour = `02${minutes} PM`;
    } else if (hourBase === "15") {
      finalHour = `03${minutes} PM`;
    } else if (hourBase === "16") {
      finalHour = `04${minutes} PM`;
    } else if (hourBase === "17") {
      finalHour = `05${minutes} PM`;
    } else if (hourBase === "18") {
      finalHour = `06${minutes} PM`;
    } else if (hourBase === "19") {
      finalHour = `07${minutes} PM`;
    } else if (hourBase === "20") {
      finalHour = `08${minutes} PM`;
    } else if (hourBase === "21") {
      finalHour = `09${minutes} PM`;
    } else if (hourBase === "22") {
      finalHour = `10${minutes} PM`;
    } else if (hourBase === "23") {
      finalHour = `11${minutes} PM`;
    } else if (hourBase === "00") {
      finalHour = `12${minutes} AM`;
    } else {
      finalHour = `${hourBase}${minutes} AM`;
    }
    return `${finalHour}`;
  };

  return (
    <Modal
      className={"gym-detail-modal"}
      changeCloseIcon={true}
      overflowModal={true}
      title={"Gym Timing"}
    >
      {/* <div className="responsive-modal-gym"> */}
      <div className="body">
        <label>Gym Name</label>
        <p className="s1 mb-8">{gymName}</p>
        <section role="table-wrapper" data-borders-inside>
          <table role="report-table">
            <thead>
              <tr>
                <th>Working Days</th>
                <th>Hours of Operations</th>
                <th>Staff Hours</th>
              </tr>
            </thead>
            <tbody>
              {days.map((item, index) => {
                const initHoursOfOperation = item.initHoursOfOperation
                  ? formatHours(item.initHoursOfOperation)
                  : "";
                const endHoursOfOperation = item.endHoursOfOperation
                  ? formatHours(item.endHoursOfOperation)
                  : "";
                const initHoursStaffHours = item.initHoursStaffHours
                  ? formatHours(item.initHoursStaffHours)
                  : "";
                const endHoursStaffHours = item.endHoursStaffHours
                  ? formatHours(item.endHoursStaffHours)
                  : "";
                const day = item.day ? item.day : "";

                const status = item.status ? item.status : false;

                return (
                  <tr
                    className="gym-location-modal-content"
                    key={`${item}-${index}`}
                  >
                    <td className="gym-location-modal-width gym-modal-table-info-title">
                      {day}
                    </td>
                    <td className="gym-location-modal-width gym-modal-table-info">
                      {status === true
                        ? `${initHoursOfOperation} - ${endHoursOfOperation}`
                        : "Closed"}
                    </td>
                    <td className="gym-location-modal-width gym-modal-table-info">
                      {status === true
                        ? `${initHoursStaffHours} - ${endHoursStaffHours}`
                        : "Closed"}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </section>
      </div>
      <footer>
        <a
          role="button"
          data-button-type="secondary"
          data-action="cancel"
          href={"/coaching-portal/settings/gym-locations"}
        >
          Close
        </a>
      </footer>
    </Modal>
  );
};
